module.exports = __webpack_public_path__ + "static/img/4.887418a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/zh/4.png
// module id = vC2Q
// module chunks = 0